module.exports = "button {\n  margin: 4px; }\n"